export default (function (value) {
  return Array.isArray(value);
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isArray.js
// module id = 2760
// module chunks = 0